/** SessionStorage key: set before `/#/admin/settings` so the settings page opens a specific tab. */
export const SETTINGS_TAB_SESSION_KEY = 'lc_settings_tab';

export type SettingsDeepLinkTab = 'providers' | 'ai' | 'social';

export function navigateToSettingsTab(tab: SettingsDeepLinkTab) {
  try {
    sessionStorage.setItem(SETTINGS_TAB_SESSION_KEY, tab);
  } catch {
    /* ignore */
  }
  window.location.hash = '/admin/settings';
}
